import * as React from "react";

export type ModuleChromeSlot = {
  title: React.ReactNode;
  eyebrow?: React.ReactNode;
  onHelpClick?: () => void;
  onSettingsClick?: () => void;
  helpLabel?: string;
  settingsLabel?: string;
};

type ModuleChromeSetter = (slot: ModuleChromeSlot | null) => void;

const ModuleChromeContext = React.createContext<ModuleChromeSetter | null>(null);

export function ModuleChromeProvider({
  children,
  setSlot,
}: {
  children: React.ReactNode;
  setSlot: ModuleChromeSetter;
}) {
  return <ModuleChromeContext.Provider value={setSlot}>{children}</ModuleChromeContext.Provider>;
}

export function useModuleChrome(slot: ModuleChromeSlot | null) {
  const setSlot = React.useContext(ModuleChromeContext);

  React.useEffect(() => {
    if (!setSlot) return undefined;
    setSlot(slot);
    return () => setSlot(null);
  }, [setSlot, slot]);
}
